import React, { useState } from 'react'
import { parsePhoneNumber } from 'libphonenumber-js'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'
import { InitialContent, RescheduleRecurrentReservationContent, SuccessContent } from './components'

import { Reservation } from 'models/Reservation'

interface ReschedulePerDateRecurrentReservationModalProps {
  handleClose: () => void
  onRefresh: () => void
  reservation: Reservation
}

interface RescheduleSuccessData {
  oldDate: Date
  newDate: Date
}

enum ModalStatuses {
  INITIAL = 'INITIAL',
  RESCHEDULE = 'RESCHEDULE',
  SUCCESS = 'SUCCESS'
}

function formatPhone(phone: string) {
  return isNaN(Number(phone)) 
    ? '' 
    : parsePhoneNumber(`+${phone}`).formatNational()
}

function getModalTitleByModalStatus(
  modalStatus: ModalStatuses,
) {
  return modalStatus === ModalStatuses.SUCCESS
    ? ''
    : <>Remarcar um dia da reserva</>
}

function getModalSubtitleByModalStatus(
  patientFullName: string, 
  modalStatus: ModalStatuses
) {
  return modalStatus === ModalStatuses.SUCCESS
    ? ''
    : <>Paciente: <strong>{patientFullName}</strong></>
}

export const ReschedulePerDateRecurrentReservationModal: React.FC<ReschedulePerDateRecurrentReservationModalProps> = ({
  handleClose,
  onRefresh,
  reservation
}) => {
  const [modalStatus, setModalStatus] = useState<ModalStatuses>(ModalStatuses.INITIAL)
  const [rescheduleSuccessData, setRescheduleSuccessData] = useState<RescheduleSuccessData[]>([])
  
  const { patientFullName, patientCellphone } = reservation
  
  const patientPhone = formatPhone(patientCellphone)
  const modalTitle = getModalTitleByModalStatus(modalStatus)
  const modalSubtitle = getModalSubtitleByModalStatus(patientFullName, modalStatus)

  function handleContinueReschedule() {
    setModalStatus(ModalStatuses.RESCHEDULE)
  }

  function handleCloseModal() {
    if (modalStatus === ModalStatuses.SUCCESS) {
      onRefresh()
    }
    
    setModalStatus(ModalStatuses.INITIAL)
    handleClose()
  }

  function handleSuccess(rescheduleSuccessData: RescheduleSuccessData[] ) {
    setModalStatus(ModalStatuses.SUCCESS)
    setRescheduleSuccessData(rescheduleSuccessData)
  }

  return (
    <ModalGeneric modalTitle={modalTitle} modalSubtitle={modalSubtitle} onCloseModal={handleCloseModal}>
      {modalStatus === ModalStatuses.INITIAL && (
        <InitialContent patientPhone={patientPhone} handleContinueReschedule={handleContinueReschedule} />
      )}

      {modalStatus === ModalStatuses.RESCHEDULE && (
        <RescheduleRecurrentReservationContent reservation={reservation} handleSuccess={handleSuccess} />
      )}

      {modalStatus === ModalStatuses.SUCCESS && (
        <SuccessContent 
          handleClose={handleCloseModal} 
          patientFullName={patientFullName}
          rescheduleSuccessData={rescheduleSuccessData}
        />
      )}
    </ModalGeneric>
  )
}